import { isIdSegment } from "@/shared/lib/id-segment";

/** The API rejects an `organizationId` longer than this (cuids are ~25 chars). */
export const ORGANIZATION_ID_MAX_LENGTH = 64;

/**
 * Trimmed organization id, or `null` when the API would drop it (blank or over
 * the cap). A dropped id turns an organization-scoped list into an unscoped
 * one, so callers must refuse `null` instead of sending it.
 */
export function normalizeOrganizationId(value: string): string | null {
  const trimmed = value.trim();
  if (trimmed.length === 0 || trimmed.length > ORGANIZATION_ID_MAX_LENGTH) return null;
  // Ids are cuids/uuids. Anything else (notably `.` and `..`, which survive
  // encodeURIComponent and which fetch resolves to another endpoint) is refused.
  return isIdSegment(trimmed) ? trimmed : null;
}
